/* upgradeBannerLogic.js — who should see which in-app upgrade banner.
 *
 * Pure on purpose (no imports, no React, no browser globals) so the rules can
 * be unit-tested from backend/tests/unit/upgradeBanner.test.js. The wording
 * and numbers live in config/upgradeBanner.js, which pulls them from
 * config/plans.js and config/planAccess.js so they cannot drift.
 *
 * THE RULES (every one is tested):
 *  - Off unless the config flag is on.
 *  - NEVER on the native iOS app (Apple Guideline 3.1.1: no upgrade prompts).
 *  - Only for signed-in, non-guest users.
 *  - Starter sees the Pro message, Pro sees the Elite message, Elite sees
 *    nothing.
 *  - Once dismissed, stays dismissed for that variant.
 */

export function pickBannerVariant({
  enabled,
  isNative,
  signedIn,
  isGuest,
  plan,
  dismissedFor = null,
}) {
  if (!enabled) return null
  if (isNative) return null
  if (!signedIn || isGuest) return null

  const variant = plan === 'starter' ? 'starter' : plan === 'pro' ? 'pro' : null
  if (!variant) return null
  if (dismissedFor === variant) return null

  return variant
}
